import {React, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import validator from 'validator'

import doUtility from '../utility'

import userStore from '../../store/slice/auth.slice'
import toast from 'react-hot-toast'

function SignUp(){    
    const navigate =  useNavigate()

    const response  = userStore((state) => state.response)
    
    const signUp = userStore((state) => state.signUp)
    
    const { register, handleSubmit, setValue, formState: { errors } } = useForm()

    const [btndisable, setbtndisable] = useState(true)

    const emailChange = (e) => {
        if(validator.isEmail(e.target.value)){
            var check = doUtility.emailVerification(e.target.value)
            if(check){
                setbtndisable(false)
                toast.dismiss()
            }else{
                toast.error('Provided Email Not Allowed', { id: "copy" })
                setbtndisable(true)
            }
        }
    }

    const cnicChange = (e) => {
        const cnic_re = /[^0-9]/g;
        const cnic_length = 13;
        let cnic = e.target.value.replace(cnic_re, "").substring(0, cnic_length);
        setValue("cnic", cnic);
    }
    
    useEffect(() => {
        if(response){
            if(response.response_code === '01'){
                toast.success(response.message)
            }else{
                toast.error(response.message)
            }
        }

        userStore.setState({ response: false })

    },[response])
    
    const onSubmit = (data) => {     
        signUp(data.email, data.cnic)
    }
    
    return (
        <div className="login-signup-form-container">
            <form className="login-form" onSubmit={handleSubmit(onSubmit)} autoComplete='false'>
                <div className="form-heading">
                    <p>Please Enter Email &amp; Cnic For Registration</p>
                </div>

                <div className="form-inputs">
                    <input type="email" name="email" placeholder="Enter Email Address" autoComplete='false'
                        {...register("email", {required: true, onChange: (e) => { emailChange(e) }})} />
                    <div className="message">{errors.email && <span>This field is required</span>}</div>

                    <input type="text" name="cnic" placeholder="Enter CNIC" autoComplete='false' 
                        {...register("cnic", { required:true, onChange: (e) => {cnicChange(e)} } )} />
                    <div className="message">{errors.cnic && <span>This field is required</span>}</div>
                </div>

                <div className="button login-signup-btn">
                    <button type="submit" className="lsbtn" onClick={(e)=>{return false}} disabled={btndisable}> Submit </button>
                    <button onClick={() => navigate(-1)} type="button" className="signup"> Back </button>
                </div>                              
            </form>
        </div>
    )
}

export default SignUp